import { render, staticRenderFns } from "./ArtefactStore.vue?vue&type=template&id=f0391110&scoped=true&"
import script from "./ArtefactStore.vue?vue&type=script&lang=js&"
export * from "./ArtefactStore.vue?vue&type=script&lang=js&"
import style0 from "./ArtefactStore.vue?vue&type=style&index=0&id=f0391110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0391110",
  null
  
)

export default component.exports